import React from 'react';
import PropTypes from 'prop-types';
import { generateBemCss } from 'general/js/helpers';
import { TinyCarousel } from 'components/tiny-carousel';

class MediaGalleryPost extends React.Component {
    constructor(props) {
        super(props);

        this.carouselOptions = {
            loop: false,
            nav: false,
            controls: true,
            touch: false,
        };
    }

    render() {
        const { model } = this.props;
        const bemCss = generateBemCss('media-post', [model.type]);
        let stateCss = '';

        if (!model.imageSrcs ||
            (model.imageSrcs && !model.imageSrcs.length)
        ) {
            stateCss = 'is-empty';
        }

        return (
            <div className={`${bemCss} ${stateCss}`}>
                {
                    model.imageSrcs.length &&
                    <TinyCarousel
                        slides={model.imageSrcs}
                        options={this.carouselOptions}
                    >
                        {model.imageSrcs.map((imageSrc) => (
                            <div key={imageSrc}>
                                <div className="media-post__bg">
                                    <img className="lazyload" data-srcset={imageSrc} alt="" />
                                </div>
                            </div>
                        ))}
                    </TinyCarousel>
                }
                <div className="media-post__content">
                    <h3 className="media-post__title">{model.title}</h3>
                    <div className="media-post__body" dangerouslySetInnerHTML={{ __html: model.body }} />
                </div>
            </div>
        );
    }
}

MediaGalleryPost.propTypes = {
    model: PropTypes.object.isRequired,
};

export default MediaGalleryPost;
